var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3H12C13.6569 3 15 4.34315 15 6V12C15 13.6569 13.6569 15 12 15H6C4.34315 15 3 13.6569 3 12V6C3 4.34315 4.34315 3 6 3ZM2 6C2 3.79086 3.79086 2 6 2H12C14.2091 2 16 3.79086 16 6V8V9V12C16 14.2091 14.2091 16 12 16H9H8.99951H8V17H8.99951V18C8.99951 19.6569 10.3427 21 11.9995 21H17.9995C19.6564 21 20.9995 19.6569 20.9995 18V12C20.9995 10.3431 19.6564 9 17.9995 9H17V8H17.9995C20.2087 8 21.9995 9.79086 21.9995 12V18C21.9995 20.2091 20.2087 22 17.9995 22H11.9995C9.79037 22 7.99951 20.2091 7.99951 18V16H6C3.79086 16 2 14.2091 2 12V6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.ccc8fe95.svg";
export { ForwardRef as ReactComponent };